interface ToastMessage {
  title: string;
  description: string;
  variant?: "default" | "destructive";
}

interface ToastGroup {
  SUCCESS: ToastMessage;
  ERROR: ToastMessage;
  CONFLICT: ToastMessage;
}

export const REGIONAL_SUBSTITUTION_MESSAGES: {
  CREATE: ToastGroup;
  UPDATE: ToastGroup;
  CANCEL: ToastGroup;
} = {
  CREATE: {
    SUCCESS: {
      title: "Vínculo criado",
      description: "A substituição foi cadastrada com sucesso.",
    },
    ERROR: {
      title: "Erro ao criar",
      description: "Não foi possível cadastrar a substituição.",
      variant: "destructive",
    },
    CONFLICT: {
      title: "Registro alterado",
      description:
        "Este vínculo foi alterado por outra pessoa. Recarregamos os dados — revise e tente de novo.",
      variant: "destructive",
    },
  },
  UPDATE: {
    SUCCESS: {
      title: "Vínculo atualizado",
      description: "A vigência foi atualizada com sucesso.",
    },
    ERROR: {
      title: "Erro ao atualizar",
      description: "Não foi possível atualizar a substituição.",
      variant: "destructive",
    },
    CONFLICT: {
      title: "Registro alterado",
      description:
        "Este vínculo foi alterado por outra pessoa. Recarregamos os dados — revise e tente de novo.",
      variant: "destructive",
    },
  },
  CANCEL: {
    SUCCESS: {
      title: "Vínculo cancelado",
      description:
        "A substituição foi cancelada; o acesso herdado deixa de valer em poucos minutos.",
    },
    ERROR: {
      title: "Erro ao cancelar",
      description: "Não foi possível cancelar a substituição.",
      variant: "destructive",
    },
    CONFLICT: {
      title: "Registro alterado",
      description:
        "Este vínculo foi alterado por outra pessoa. Recarregamos a lista — revise e tente de novo.",
      variant: "destructive",
    },
  },
};
